export const setPatientCredentials = (credentials) => {
  // Store in localStorage when credentials are set (only if they exist)
  if (credentials) {
    localStorage.setItem('patientCredentials', credentials);
  } else {
    localStorage.removeItem('patientCredentials');
  }

  return {
    type: 'patient-login/SET_PATIENT_CREDENTIALS',
    payload: credentials
  };
};

export const setPatientAuthenticated = (isAuthenticated) => {
  localStorage.setItem('isAuthenticated', isAuthenticated ? 'true' : 'false');
  return {
    type: 'patient-login/SET_PATIENT_AUTHENTICATED',
    payload: isAuthenticated
  };
};

export const patientLoginActions = {
  LOGIN_PATIENT: {
    REQUEST: 'patient-login/login-patient-request',
    SUCCESS: 'patient-login/login-patient-success',
    FAILURE: 'patient-login/login-patient-failure',
    RESET: 'patient-login/login-patient-reset' // Optional: to reset the state (e.g., clear form on error or after successful login)
  },
  SET_PATIENT: {
    CREDENTIALS: 'patient-login/SET_PATIENT_CREDENTIALS',
    AUTHENTICATED: 'patient-login/SET_PATIENT_AUTHENTICATED'
  }
};

export const patientLogoutActions = {
  LOGOUT_PATIENT: {
    REQUEST: 'patient-logout/logout-patient-request',
    SUCCESS: 'patient-logout/logout-patient-success',
    FAILURE: 'patient-logout/logout-patient-failure',
    RESET: 'patient-logout/logout-patient-reset'
  }
};
